"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _default = function _default(currencyCode) {
  var currency = _I18n.default.currencySymbols[currencyCode];
  return currency ? currency.symbol_native : null;
};

exports.default = _default;
module.exports = exports.default;